import * as React from 'react';
import { Linked, useIO, useModel } from '@type-r/react';
import { PopupIODialog, Flex, FormCheckbox, FormLabel, asDateTime } from 'lqx-react';
import { InvoiceModel } from 'api/invoice';
import { attributes, Collection, Events } from '@type-r/models';
import { Document } from '../../../../../../api/uploads';
import CommentIcon from '@material-ui/icons/Comment';
import { DialogLoading } from '../../statement/dialogs/report-actions';
import { List, ListItem } from '@material-ui/core';

const LocalState = attributes({
    toSend: [Document],
    invoiceUploads: Collection.ofRefs(Document)
});

const filterByInvoice = (documents) => {
    return documents && documents.length ? documents.reduce((x, y) => {
        if (y.document_type === 'Invoice')
            x.push(y);
        return x;
    }, []) : [];
}

export const EmailInvoiceDialog = ({ $isOpen, invoice }: { $isOpen: Linked<boolean>, invoice: InvoiceModel }) => {

    let state = useModel(LocalState);

    const isReady = useIO(async () => {
        await invoice.relationship.cpInvoicing.fetch();
        state.invoiceUploads = filterByInvoice(invoice.uploads);
    }, []);

    const SendInvoiceEmail = async () => {
        let uploadsToSend = state.toSend.map(x => {
            return {
                Id: x.id,
                DocumentType: x.document_type,
                FileName: x.file_name,
                FilePath: x.file_path,
                FileType: x.file_type
            }
        });
        await invoice.sendInvoiceEmail(uploadsToSend);
    }

    const isEmpty = (arr: any[]) => arr && !arr.length;

    return (
        <PopupIODialog
            $isOpen={$isOpen}
            title={"Send Invoices"}
            actionLabel={"Send"}
            success={"Invoice Sent Succesfully"}
            onSuccess={() => Events.trigger("Invoice:refresh")}
            doIO={SendInvoiceEmail}
            disabled={
                !isReady
                || isEmpty(state.invoiceUploads as any)
                || isEmpty(state.toSend as any)
                || isEmpty(invoice.relationship.cpInvoicing.emails)
            }
        >
            {
                !isReady
                    ? <DialogLoading></DialogLoading>
                    : isEmpty(invoice.relationship.cpInvoicing.emails)
                        ? <p>No recipient set on Customer Profile - Invoicing.</p>
                        : isEmpty(state.invoiceUploads as any)
                            ? <p>No document of type invoice is attached.</p>
                            : <>
                                <p> Do you want to send invoice via email to the following recipients?</p>
                                <List>
                                    {invoice.relationship.cpInvoicing.emails.map(email =>
                                        <ListItem key={email as any}><b>{email}</b></ListItem>
                                    )}
                                </List>
                                <p>Please select from the following Invoices:</p>
                                <InvoiceUploads uploads={state.invoiceUploads} toSend={state.toSend}></InvoiceUploads>
                            </>
            }
        </PopupIODialog>
    );
}

const InvoiceUploads = ({ uploads, toSend }: { uploads: Collection<Document>, toSend: Collection<Document> }) => {
    return (
        <Flex column>
            {uploads.map(upload =>
                <Flex row key={upload.cid}>
                    <FormCheckbox $checked={toSend.$includes(upload)} />
                    <FormLabel> {upload.file_name}</FormLabel>
                    <FormLabel> {asDateTime(upload.upload_timestamp)}</FormLabel>
                    {
                        upload.file_comments
                            ? <FormLabel title={upload.file_comments}> <CommentIcon /></FormLabel>
                            : <FormLabel><Flex grow /></FormLabel>
                    }
                </Flex>
            )}
        </Flex>
    );
}
